import { TrendingUp, TrendingDown, BarChart2 } from "lucide-react";
import { C } from '../constants';

export default function CatalystCard({ catalyst }) {
  if (!catalyst) return null;
  const title  = catalyst.title || catalyst.name || catalyst.driver || catalyst.heading || catalyst.header || "";
  const desc   = catalyst.description || catalyst.detail || catalyst.body || catalyst.summary || catalyst.text || "";
  if (!title && !desc) return null;
  const ri = (catalyst.impact || catalyst.sentiment || "neutral").toString().toLowerCase();
  const impact = ri.includes("pos")||ri.includes("bull") ? "positive" : ri.includes("neg")||ri.includes("bear") ? "negative" : "neutral";
  const cfg = {
    positive: { icon:<TrendingUp size={16} strokeWidth={2} color={C.green}/>,  color:C.green,  bg:"rgba(0,200,5,0.08)",    pill:"Positive" },
    negative: { icon:<TrendingDown size={16} strokeWidth={2} color={C.neg}/>,  color:C.neg,    bg:"rgba(255,59,48,0.08)",  pill:"Headwind" },
    neutral:  { icon:<BarChart2 size={16} strokeWidth={2} color={C.gold2}/>,   color:C.gold2,  bg:"rgba(201,168,76,0.08)", pill:"Neutral"  },
  }[impact];
  return (
    <div style={{ background:C.card2, border:`1px solid ${C.bord}`, borderRadius:14, padding:"14px 16px", display:"flex", gap:12 }}>
      <div style={{ width:34, height:34, borderRadius:10, flexShrink:0, background:cfg.bg, display:"flex", alignItems:"center", justifyContent:"center", marginTop:1 }}>{cfg.icon}</div>
      <div style={{ flex:1 }}>
        <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4, flexWrap:"wrap" }}>
          <span style={{ fontSize:13, fontWeight:700, color:C.text }}>{title}</span>
          <span style={{ fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:20, background:cfg.bg, color:cfg.color }}>{cfg.pill}</span>
        </div>
        <div style={{ fontSize:12, color:C.soft, lineHeight:1.6, marginBottom:catalyst.dollarImpact?5:0 }}>{desc}</div>
        {catalyst.dollarImpact && <div style={{ fontSize:12, fontWeight:700, color:cfg.color }}>{impact==="positive"?"↑":"↓"} {catalyst.dollarImpact} impact on fair value</div>}
      </div>
    </div>
  );
}
